export const fixedCategoryKey = (value) =>
  (value || '').toString().trim().toUpperCase().replace(/\s+/g, '');

export const siteIdsMatch = (firstSiteId, secondSiteId) =>
  firstSiteId !== null &&
  firstSiteId !== undefined &&
  secondSiteId !== null &&
  secondSiteId !== undefined &&
  String(firstSiteId) === String(secondSiteId);

const toOption = (value, index) => ({
  key: index,
  label: value,
  value,
});

const uniqueOptions = (values) => {
  const seen = new Set();
  return values.reduce((options, value) => {
    const key = fixedCategoryKey(value);
    if (!key || seen.has(key)) {
      return options;
    }
    seen.add(key);
    options.push(toOption(value, options.length));
    return options;
  }, []);
};

export const getFixedCategoryOptions = (tree, selectedSubCategory = '') => {
  const subCategoryKey = fixedCategoryKey(selectedSubCategory);
  const categories = tree?.categories || [];

  return uniqueOptions(
    categories
      .filter((category) => (category.subCategories || []).length > 0)
      .filter((category) =>
        !subCategoryKey ||
        (category.subCategories || []).some((subCategory) =>
          fixedCategoryKey(subCategory.subCategory) === subCategoryKey
        )
      )
      .map((category) => category.category)
  );
};

export const getFixedSubCategoryOptions = (tree, selectedCategory = '') => {
  const categoryKey = fixedCategoryKey(selectedCategory);
  const categories = tree?.categories || [];

  return uniqueOptions(
    categories
      .filter((category) =>
        !categoryKey || fixedCategoryKey(category.category) === categoryKey
      )
      .flatMap((category) =>
        (category.subCategories || []).map((subCategory) => subCategory.subCategory)
      )
  ).sort((first, second) => first.label.localeCompare(second.label));
};

export const isFixedCategoryPairAllowed = (tree, category, subCategory) => {
  const categoryKey = fixedCategoryKey(category);
  const subCategoryKey = fixedCategoryKey(subCategory);

  if (!categoryKey || !subCategoryKey) {
    return true;
  }

  return (tree?.categories || []).some((fixedCategory) =>
    fixedCategoryKey(fixedCategory.category) === categoryKey &&
    (fixedCategory.subCategories || []).some(
      (fixedSubCategory) =>
        fixedCategoryKey(fixedSubCategory.subCategory) === subCategoryKey
    )
  );
};
